import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { storage } from '../../../helpers/Firebase';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    PR_SUPPLIER,
    PR_DELIVERY_ORDER,
    PR_LIST,
    PR_LIST_WITHOUT_PR,
    PR_UPLOAD,
    PR_UPLOAD_SET,
} from "../../actions";

import {
    PRSupplierSuccess,
    PRSupplierError,
    PRDeliveryOrderSuccess,
    PRDeliveryOrderError,
    PRListSuccess,
    PRListError,
    PRListWithoutPRSuccess,
    PRListWithoutPRError,
    PRUploadSuccess,
    PRUploadError,
    PRUploadSetSuccess,
    PRUploadSetError
} from '../../actions';


export function* watchPRSupplier() {
    yield takeEvery(PR_SUPPLIER, onPRSupplier);
}

export function* watchPRDeliveryOrder() {
    yield takeEvery(PR_DELIVERY_ORDER, onPRDeliveryOrder);
}

export function* watchPRList() {
    yield takeEvery(PR_LIST, onPRList);
}

export function* watchPRListWithoutPR() {
    yield takeEvery(PR_LIST_WITHOUT_PR, onPRListWithoutPR);
}

export function* watchPRUpload() {
    yield takeEvery(PR_UPLOAD, onPRUpload);
}

export function* watchPRUploadSet() {
    yield takeEvery(PR_UPLOAD_SET, onPRUploadSet);
}

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onPRSupplierAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'paymentreceipt/supplier', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onPRDeliveryOrderAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'paymentreceipt/deliveryorder', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onPRListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'paymentreceipt/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
}


const onPRListWithoutPRAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'paymentreceipt/listwithoutpr', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onPRUploadAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'paymentreceipt/upload', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onPRUploadSetAsync = async (file) => {
    var storageRef = storage.ref();
    let filename = file.name;
    return await new Promise((success, reject) => {
        var uploadTask = storageRef.child(storagePath + '/finance/paymentreceipt/' + filename).put(file);
        uploadTask.on('state_changed',
            function (snapshot) {
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
            },
            function (error) {
                reject({ name: filename, original: file.name, message: error.code, url: '', type: file.type, size: file.size, path: 'healthregistration/' })
            },
            function () {
                uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                    success({ message: 'success', name: filename, original: file.name, url: downloadURL });
                });
            });
    });
};



function* onPRSupplier(data) {
    try {
        const response = yield call(onPRSupplierAsync, data.payload);
        yield put(PRSupplierSuccess(response.data));
    } catch (error) {
        yield put(PRSupplierError(error));
    }
}

function* onPRDeliveryOrder(data) {
    try {
        const response = yield call(onPRDeliveryOrderAsync, data.payload);
        yield put(PRDeliveryOrderSuccess(response.data));
    } catch (error) {
        yield put(PRDeliveryOrderError(error));
    }
}

function* onPRList(data) {
    try {
        const response = yield call(onPRListAsync, data.payload);
        yield put(PRListSuccess(response.data));
    } catch (error) {
        yield put(PRListError(error));
    }
}

function* onPRListWithoutPR(data) {
    try {
        const response = yield call(onPRListWithoutPRAsync, data.payload);
        yield put(PRListWithoutPRSuccess(response.data)); yg
    } catch (error) {
        yield put(PRListWithoutPRError(error));
    }
}


function* onPRUpload(data) {
    try {
        const response = yield call(onPRUploadAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(PRUploadSuccess(response.data));
    } catch (error) {
        yield put(PRUploadError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onPRUploadSet({ payload }) {
    const { file } = payload;
    try {
        const response = yield call(onPRUploadSetAsync, file);
        console.log("response" + JSON.stringify(response));
        if (response.message === 'success') {

            yield put(PRUploadSetSuccess(response));

        }
        else {
            yield put(PRUploadSetError(response));
        }
    } catch (error) {
        yield put(PRUploadSetError({ name: '', original: file.name, message: error, url: '', path: '' }))
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchPRSupplier),
        fork(watchPRDeliveryOrder),
        fork(watchPRList),
        fork(watchPRListWithoutPR),
        fork(watchPRUpload),
        fork(watchPRUploadSet)
    ]);
}